import './index.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import App from './application/containers/App';
import { env } from './framework/utils/EnvUtils';
import { suppressLog } from './framework/utils/ProductionUtils';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// console log suppression in production mode.
if (env.ENVIRONMENT === 'PRODUCTION') {
  suppressLog();
}

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container);

// FullCalendarのバグのため一時的にStrictModeを解除
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
